<template>
  <div class="contact">
    <div class="contact_area">
      <div style="width: 520px; margin: auto">
        <div>Votre demande concerne</div>

        <a-select
          v-model:value="info.object"
          :options="contactList"
          :disabled="sending"
          style="width: 100%"
        >
        </a-select>

        <a-textarea
          v-model:value="info.message"
          :disabled="sending"
          :rows="8"
          style="margin-top: 10px"
        />

        <a-divider></a-divider>

        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
          "
        >
          <div>
            <input
              @change="uploadFile($event)"
              style="display: none"
              type="file"
              ref="file_input"
            />

            <a-button
              :disabled="sending"
              @click="openFileInput()"
              type="dashed"
              shape="round"
            >
              Joindre un fichier
            </a-button>
          </div>

          <div>
            <a-button
              :loading="sending"
              @click="sendMessage()"
              type="primary"
              shape="round"
              :disabled="textareaIsEmpty"
              ghost
            >
              Envoyer
            </a-button>
          </div>
        </div>

        <div v-for="file in files" class="uploaded_files" :key="file.uuid">
          <div style="width: 400px; padding: 6px 10px; color: darkgrey">
            {{ file.original_name }}
          </div>
          <div>
            <a-button type="link" :href="file.src">Voir</a-button>
          </div>
          <div>
            <a-button type="link" @click="deleteFile(file.uuid)">
              Supprimer
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from "ant-design-vue";

export default {
  name: "portefeuille",
  components: {},
  data: () => {
    return {
      contactList: [
        { value: "gestion_sante", label: "La gestion santé" },
        { value: "gestion_prevoyance", label: "La gestion prévoyance" },
        { value: "commercial", label: "Le commercial" },
      ],
      files: [],
      token: 0,
      info: {
        object: "gestion_sante",
        message: "",
      },
      sending: false,
    };
  },
  methods: {
    openFileInput() {
      this.$refs.file_input.click();
    },
    uploadFile(event) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);

      let config = {
        header: {
          "Content-Type": "multipart/form-data",
        },
      };

      this.$axios
        .post("/data/upload/file", formData, config)
        .then((r) => {
          if (r.status === 201) {
            this.files.push(r.data);
          }
        })
        .catch((error) => {
          message.warning(error.response.data.error_message);
        });

      this.$refs.file_input.value = null;
    },
    deleteFile(uuid) {
      this.axios.delete("/data/delete/file/" + uuid).then((r) => {
        if (r.status == 200) {
          this.files = this.files.filter((f) => f.uuid != uuid);
        }
      });
    },
    sendMessage() {
      if (this.textareaIsEmpty) {
        return;
      }

      message.config({
        top: "5vh",
      });

      this.sending = true;

      message.destroy();

      this.axios
        .post("/data/contact", {
          info: this.info,
          files_uuids: this.files,
        })
        .then((r) => {
          if (r.status === 200) {
            this.files = [];
            this.info.message = "";
            this.sending = false;

            message.success(
              `Votre message a bien été envoyé. Nous reviendrons vers vous dans les meilleurs délais.`
            );

          }
        })
        .catch((_) => {
          message.error("Le problème est survenu");
          this.sending = false;
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
  computed: {
    textareaIsEmpty(){
      return this.info.message.trim() == ""
    }
  },
  mounted() {
    this.token = 0;
  },
};
</script>
<style scoped>
.contact_area {
  padding: 180px 20px 0 100px;
}
.uploaded_files {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 0 2px 0 #ccc;
  display: flex;
  margin: 8px 0;
  user-select: none;
}
</style>
